import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { LoadingOutlined } from '@ant-design/icons';
import NormalInput from '../../inputs/normalInput';
import CountDown from '../../countdown';
import auth from '../../../../utils/auth';

const ForgotPasswordStep = (props) => {
  const onSubmit = () => {
    props.onSubmit();
  };

  const onSendCodeAgain = () => {
    props.onSendCodeAgain();
  };

  const onStopCountDown = () => {
    props.onStopCountDown();
  };
  return (
    <form className="forgot-password" onSubmit={onSubmit}>
      <div className="instruction">
        A verification code has been sent to your email:
        {' '}
        <span>{auth.getLoginData()?.email}</span>
      </div>
      <NormalInput
        className="mt-10"
        name="verificationCode"
        title="Verification code"
        isRequired
        isUseForm
        control={props.form?.control}
        placeholder="Verification code"
        errMsg={props.form?.formState?.errors?.verificationCode?.message}
      />
      <NormalInput
        className="mt-10"
        name="newPassword"
        title="New password"
        type="password"
        isRequired
        isUseForm
        control={props.form?.control}
        placeholder="New password"
        errMsg={props.form?.formState?.errors?.newPassword?.message}
      />
      <div className="send-code-again-wrapper">
        <u className={classnames('send-code-again', !props.isCountDown ? '' : 'disabled')} onClick={onSendCodeAgain}>
          Send code again?
          {' '}
          {props.resendCodeLoading && <LoadingOutlined />}
        </u>
        <p className="count-down">
          { props.isCountDown && <CountDown startTime={props.startTime} onStopCountDown={onStopCountDown} />}
        </p>

      </div>
    </form>
  );
};

ForgotPasswordStep.defaultProps = {
  form: {},
  startTime: '',
  isCountDown: false,
  resendCodeLoading: false,

  onStopCountDown: () => {},
  onSubmit: () => {},
  onSendCodeAgain: () => {},
};

ForgotPasswordStep.propTypes = {
  form: PropTypes.shape({}),
  startTime: PropTypes.string,
  isCountDown: PropTypes.bool,
  resendCodeLoading: PropTypes.bool,

  onStopCountDown: PropTypes.func,
  onSubmit: PropTypes.func,
  onSendCodeAgain: PropTypes.func,
};

export default ForgotPasswordStep;
